import { ManageTeamInvitesModal } from "./manageTeamInvitesModal"
import { IconButton, useDisclosure, Tooltip } from "@chakra-ui/react";
import { AiOutlineTeam } from '@react-icons/all-files/ai/AiOutlineTeam';
import { VerifyAlertDialog } from 'components';
import { useLoggedinUser } from "lib/hooks";

export const ManageTeamInvitesButton = () => {
  const { data: user } = useLoggedinUser();
  const inviteModal = useDisclosure();
  const verifyModal = useDisclosure();

  const onClick = (): void => user.verified ? inviteModal.onOpen() : verifyModal.onOpen();

  return (
    <>
      <ManageTeamInvitesModal isOpen={inviteModal.isOpen} onClose={inviteModal.onClose} />
      <VerifyAlertDialog
        isOpen={verifyModal.isOpen}
        onClose={verifyModal.onClose}
        title={"You’re so close! One final step"}
        content={`To invite team members, you need to complete your account set up. It’s super easy. We sent a verification link to ${user?.email}. Please go to your inbox and click that link to get full access to your Packs account.`}
      />
      <Tooltip label="Manage team invites" hasArrow>
        <IconButton 
          variant="ghost" 
          onClick={onClick}
          aria-label="Manage Team Invites"
          fontSize="25px"
          data-testid="team-members-invite-modal-button"
          icon={<AiOutlineTeam color="var(--color-text-secondary)" />}
        />
      </Tooltip>
    </>
  )
};
